import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('bsnbry-rovodev-agents-panel');
	},
};
